<ng-container>
  <div class="billing-summary-container" [class.billing-summary-tall]="currentStep >= 6">
    <div class="billing-summary-header d-flex flex-column w-100">
      <span class="header">{{ 'nextService' | translate }}</span>
      <div class="d-flex" *ngIf="summaryData.vehicleInformation?.licensePlate?.length">
        <div class="vehicle-info">
          <img [src]="getChassisTypeIcon(summaryData.vehicleInformation.chassisTypeId)" alt="Car" class="vehicle-img" />
          <div class="vehicle-info-data">
            <p class="title" style="margin-bottom: 0px;">{{ summaryData.vehicleInformation.licensePlate!.length }} {{
              summaryData.vehicleInformation.licensePlate!.length == 1 ? ('vehicle' | translate) : ('vehicles' |
              translate) }}</p>
            <p style="margin-bottom: 0px;" *ngIf="summaryData.vehicleInformation.licensePlate!.length == 1">
              {{ summaryData.vehicleInformation.licensePlate }}
            </p>
          </div>
        </div>
        <!-- <div *ngIf="moreThanOneLicensePlate" class="vehicle-info multiple-vehicles">
          <img src="../../assets/icons/card-cars-icon.svg" alt="Car" class="vehicle-img" />
          <div class="vehicle-info-data">
            <p class="title">{{ licensePlateCount }} {{ 'vehicles' | translate }}</p>
            <p class="license-plates">
              {{ 'chassis' | translate }}
            </p>
          </div>
        </div> -->
      </div>
    </div>

    <ng-container *ngIf="summaryData &&
        summaryData.locationInfo?.originAddress && summaryData.locationInfo?.destinationAddress
      ">
      <div class="summary-container" [ngClass]="{ 'summary-container-last-step': currentStep === 6 }">
        <app-distance-time-box *ngIf="currentStep !== 2 && !(isSameAddress$ | async)" [summaryData]="summaryData"
          [showData]="true">
        </app-distance-time-box>
        <app-address-box [summaryData]="summaryData"></app-address-box>
        <app-additional-info [summaryData]="summaryData"></app-additional-info>
        <app-contact-info [summaryData]="summaryData"></app-contact-info>
        <app-document-info [summaryData]="summaryData" *ngIf="currentStep >= 6"></app-document-info>
        <app-comments [summaryData]="summaryData"></app-comments>
        <app-pricing-summary *ngIf="!isOpenForm()" [summaryData]="summaryData" [currentStep]="currentStep"
          [extras]="extras" [promotionCode]="promotionCode" [promotionCodeValidator]="promotionCodeValidator"
          [promotionCodeValue]="promotionCodeValue"></app-pricing-summary>
        <app-cancellation-policy [summaryData]="summaryData" [currentStep]="currentStep"></app-cancellation-policy>

        <div *ngIf="returnTransferSummaryData.locationInfo?.originAddress" class="summary-container-transfer">
          <app-address-box [summaryData]="returnTransferSummaryData"></app-address-box>
          <app-additional-info [summaryData]="returnTransferSummaryData"></app-additional-info>
          <app-contact-info [summaryData]="returnTransferSummaryData"></app-contact-info>
          <app-comments [summaryData]="returnTransferSummaryData"></app-comments>
          <app-pricing-summary *ngIf="!isOpenForm()" [summaryData]="returnTransferSummaryData"
            [currentStep]="currentStep" [extras]="extras" [promotionCode]="promotionCode"
            [promotionCodeValidator]="promotionCodeValidator"
            [promotionCodeValue]="promotionCodeValue"></app-pricing-summary>
          <app-cancellation-policy [summaryData]="returnTransferSummaryData"
            [currentStep]="currentStep"></app-cancellation-policy>
        </div>

        <div *ngIf="ReplacementVehicleSummaryData.locationInfo?.originAddress" class="summary-container-transfer">
          <app-address-box [summaryData]="ReplacementVehicleSummaryData"></app-address-box>
          <app-additional-info [summaryData]="ReplacementVehicleSummaryData"></app-additional-info>
          <app-contact-info [summaryData]="ReplacementVehicleSummaryData" [hideIsParticular]="true"></app-contact-info>
          <app-comments [summaryData]="ReplacementVehicleSummaryData"></app-comments>
          <app-pricing-summary *ngIf="!isOpenForm()" [summaryData]="ReplacementVehicleSummaryData"
            [currentStep]="currentStep" [extras]="extras" [promotionCode]="promotionCode"
            [promotionCodeValidator]="promotionCodeValidator"
            [promotionCodeValue]="promotionCodeValue"></app-pricing-summary>
          <app-cancellation-policy [summaryData]="ReplacementVehicleSummaryData"
            [currentStep]="currentStep"></app-cancellation-policy>
        </div>
      </div>
    </ng-container>

    <app-checkout-container class="w-100 h-100" *ngIf="
        (currentStep === 6 || currentStep === 4) &&
        !returnTransferSummaryData.locationInfo?.originAddress && !ReplacementVehicleSummaryData.locationInfo?.originAddress
      " [summaryData]="summaryData" [currentStep]="currentStep" [disabledButtonLastStep]="disabledButtonLastStep"
      [buttonText]="buttonText" [returnTransferSummaryData]="returnTransferSummaryData"
      [minimumConditions]="minimumConditions" [termsAndConditions]="termsAndConditions" [SavingLoading]="SavingLoading"
      [productSelectionStepForm]="productSelectionStepForm" (buttonClick)="handleButtonClick()"
      (deletePromoCode)="deletePromotionCode()"></app-checkout-container>
    <app-checkout-container class="w-100 h-100" *ngIf="
        (currentStep === 6 || currentStep === 4 || currentStep === 7) &&
        returnTransferSummaryData.locationInfo?.originAddress
      " [summaryData]="summaryData" [currentStep]="currentStep" [disabledButtonLastStep]="disabledButtonLastStep"
      [buttonText]="buttonText" [returnTransferSummaryData]="returnTransferSummaryData"
      [minimumConditions]="minimumConditions" [termsAndConditions]="termsAndConditions" [SavingLoading]="SavingLoading"
      [productSelectionStepForm]="productSelectionStepForm" (buttonClick)="handleButtonClick()"
      (deletePromoCode)="deletePromotionCode()"></app-checkout-container>
    <app-checkout-container class="w-100 h-100" *ngIf="
              (currentStep === 6 || currentStep === 4 || currentStep === 7) &&
              ReplacementVehicleSummaryData.locationInfo?.originAddress
            " [summaryData]="summaryData" [currentStep]="currentStep" [disabledButtonLastStep]="disabledButtonLastStep"
      [buttonText]="buttonText" [ReplaceVehicleSummaryData]="ReplacementVehicleSummaryData"
      [minimumConditions]="minimumConditions" [termsAndConditions]="termsAndConditions" [SavingLoading]="SavingLoading"
      [productSelectionStepForm]="productSelectionStepForm" (buttonClick)="handleButtonClick()"
      (deletePromoCode)="deletePromotionCode()"></app-checkout-container>
  </div>
</ng-container>

<app-modal-minimum-conditions></app-modal-minimum-conditions>
<app-modal-promotion-code [(promotionCode)]="promotionCode" [promotionCodeValidator]="promotionCodeValidator"
  (validatePromoCode)="validatePromotionCode()"></app-modal-promotion-code>
<app-modal-cancellation-policy></app-modal-cancellation-policy>
<app-modal-refueling-fee></app-modal-refueling-fee>